import styled from "styled-components";
import Box from "../../Components/Box";

const StyledPage = styled(Box)`

min-height : 47vh;

* {
    background-color : inherit!important;
}

p ,h1 , h2 , h3 , h4, h5, h6{
    margin-bottom : 20px;
}

ul{
    list-style : inherit;
}

@media only screen and (min-width : 2300px){
    min-height : 50vw;
}

@media only screen and (max-width : 900px){
    padding-top : 7rem;
}


`

export default StyledPage